import { Outlet } from 'react-router-dom';

import { useInitLayoutQuery } from '@/entities/layout';
import { mockConsignments } from '@/data/mockData';

import { Sidebar } from './sidebar';
import { Header } from './header';
import { StorageSidebar } from './storage-sidebar';

export const PrivateLayout = () => {
  const { isLoading: isLayoutLoading, error } = useInitLayoutQuery();
  const consignmentCount = mockConsignments.length;

  if (isLayoutLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p>Loading application...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center text-destructive">
          <p>Failed to load application data</p>
          <p className="text-sm text-muted-foreground mt-1">Please try refreshing the page</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header consignmentCount={consignmentCount} />
        <div className="flex flex-1 overflow-hidden">
          <main className="flex-1 overflow-y-auto bg-secondary/10 p-6">
            <div className="mx-auto max-w-7xl space-y-6">
              <Outlet />
            </div>
          </main>
          <StorageSidebar />
        </div>
      </div>
    </div>
  );
};
